import type { PreOrderData } from '@/api/cashier/cashierType'
import { deepClone } from '@alova/shared'
import { defineStore } from 'pinia'

type CashierLeaveCallback = () => void

// 初始化状态
const PreOrderInfoState: PreOrderData = {
  prePayNo: '',
  allowedPaymentTypes: [],
  totalAmount: '0',

}

// 收银台预订单信息
export const preOrderStore = defineStore(
  'cashier',
  () => {
    const preOrder = ref<PreOrderData>(deepClone(PreOrderInfoState))
    let leaveCashierCallback: CashierLeaveCallback | null = null

    // 设置预订单信息
    function setPreOrder(val: PreOrderData, callback?: CashierLeaveCallback) {
      preOrder.value = val
      leaveCashierCallback = callback || null
    }

    // 设置离开收银台时需要执行的回调
    function setLeaveCashierCallback(callback: CashierLeaveCallback) {
      leaveCashierCallback = callback
    }

    // 清空离开收银台回调，避免支付成功后重复触发
    function clearLeaveCashierCallback() {
      leaveCashierCallback = null
    }

    // 执行并清空离开收银台回调
    function runLeaveCashierCallback() {
      const callback = leaveCashierCallback
      leaveCashierCallback = null

      try {
        callback?.()
      }
      catch (err) {
        console.error('收银台离开回调执行失败:', err)
      }
    }

    // 删除预订单信息
    function removePreOrder() {
      preOrder.value = deepClone(PreOrderInfoState)
    }

    return {
      preOrder,
      setPreOrder,
      setLeaveCashierCallback,
      clearLeaveCashierCallback,
      runLeaveCashierCallback,
      removePreOrder,
    }
  },
  {
    persist: false,
  },
)
